export const incrementInteractionCountEffect = (options = {}) => {
  const { setInteractionCount } = options;
  return () => setInteractionCount((count) => count + 1);
};

export const resetInteractionCountEffect = (options = {}) => {
  const { setInteractionCount } = options;
  return () => setInteractionCount(0);
};
